import useSWR from 'swr';
import { KamibotStatus, ApiResponse } from '@/types';

const fetcher = async (url: string) => {
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error('서버 상태를 가져오는데 실패했습니다');
  }
  
  const data: ApiResponse<KamibotStatus> = await response.json();
  
  if (!data.success || !data.data) {
    throw new Error(data.message || '서버 상태를 가져오는데 실패했습니다');
  }
  
  return data.data;
};

export function useBotStatus() {
  const { data, error, isLoading, mutate } = useSWR<KamibotStatus>(
    '/api/kamibot/status',
    fetcher,
    {
      refreshInterval: 500, // 0.5초마다 갱신 (히어로 실시간 근황 + 롤링 카운트업)
      revalidateOnFocus: false, // 탭 포커스시 재검증 비활성화 (불필요한 요청 방지)
      dedupingInterval: 400, // 중복 요청 방지 간격 (갱신 주기보다 짧게)
      fallbackData: {
        status: "불러오는 중...",
        guilds: 20000, // 기본값으로 2만 서버 표시
        users: 1000000, // 기본값으로 100만 사용자 표시
        online_users: 500000, // 기본값으로 50만 사용자 표시
        current_time: new Date().toISOString(),
        uptime: "N/A",
        total_memory: 0,
        used_memory: 0,
        free_memory: 0,
        total_threads: 0,
        active_threads: 0,
        idle_threads: 0,
        audio_send_handlers: 0,
        cpu_usage: 0,
        events_per_second: 0
      }
    }
  );

  return {
    status: data,
    isLoading,
    isError: error,
    refresh: mutate
  };
}
